<template>
    <transition name="modal">
        <div>
            <div class="modal" tabindex="-1" role="dialog" @keyup.esc="closeModal">
                <div class="modal__dialog">
                    <button class="modal__close" type="button" @click="closeModal">
                        x
                    </button>
                    <div class="modal__content">
                        <slot />
                    </div>
                </div>
            </div>
            <div class="modal-backdrop" role="presentation" @click="clickBackdrop" />
            <div v-if="isLoading" class="spinner-wrapper">
                <div class="overlay" />
                <span class="spinner" />
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        isLoading: {
            type: Boolean,
            required: false
        },
        closeOnClickBackdrop: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        /**
         * Handle clicks on the backdrop.
         */
        clickBackdrop() {
            if (this.closeOnClickBackdrop) {
                this.closeModal();
            }
        },
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        }
    }
};
</script>
